export const environment = {
  production: false,
  backend: '/api/backend',
  backendStomp: '/api/backend/ws',
};
